<template>
  <div id="app" v-cloak>
    <router-view />
    <template v-if="curLoginDialog">
      <login :canClose=true />
    </template>
    <div class="article_right_tab_container">
      <!-- <el-link :underline="false" @click="openRebackDialog">
        <div class="article_right_tab_large total_tab_reback">
        </div>
      </el-link> -->
    </div>

    <template v-if="curPriceDialog">
      <price :code="priceCode" :show=true @close="curPriceDialog = false" />
    </template>

  </div>
</template>
<script>
import login from './app/login'
import bindMobile from './components/bindMobile'
import price from './app/price.vue'
export default {
  components: {
    login,
    bindMobile,
    price
  },
  name: 'App',
  data: function () {
    return {

      userInfo: null,

      curLoginDialog: false,
      curPriceDialog: false,
      priceCode: '',
      modifyDialogVisible: false
    }
  },
  metaInfo () {
    return {
      title: '弈写AI辅助写作'
    }
  },
  methods: {

  },
  computed: {
    showLoginDialog () {
      return this.$store.state.loginDialogVisible
    },
    hideLoginDialog () {
      return this.$store.state.hideLoginDialog
    },
    priceDialog () {
      return this.$store.state.priceDialogVisible
    }

  },
  watch: {
    showLoginDialog: function () {
      this.curLoginDialog = true
    },
    hideLoginDialog: function () {
      this.curLoginDialog = false
    },
    priceDialog: function () {
      console.log('打开购买框')
      this.curPriceDialog = true
      this.priceCode = this.$store.state.priceCode
    }
  },
  mounted () {

  }
}

</script>

<style lang="less" >
@import 'assets/css/index.less';

.bindMobileDialog {
  background: #fff0;
  box-shadow: none;

  .el-dialog__header {
    background: #2c8eff;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;

    .el-dialog__title {
      color: white !important;
    }
  }

  .el-dialog__body {
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    background-color: white;
  }
}

.imgCaptcha {
  width: 100px;
}

.modifyMobileForm {
  .el-input-group__append {
    z-index: 99;
    background-color: white;
    padding: 0px 5px;
    border-left: 0px !important;
  }
}

.loginBtn {
  width: 186px;
}

.loginDialog {
  background-color: rgba(0, 0, 0, 0);
  border: 0px;
  box-shadow: none;
  padding: 0px;

  .el-dialog {
    overflow: hidden;
    border-radius: 6px;
  }

  .el-dialog__body {
    padding: 0px;
    background-color: rgba(0, 0, 0, 0);
  }

  .el-dialog__header {
    height: 0px !important;
    padding: 0px !important;
  }

  .el-dialog__headerbtn {
    z-index: 9999;
  }
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // background-color: #FAFAFA;
}

html,
body {
  width: 100%;
  min-height: 100%;
  margin: 0px;
  padding: 0px;
  overflow: hidden;
}

.loginDialogContainer {
  background-size: 100%;
  background-color: #0000;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    border-radius: 16px;
    background-color: white;
  }

  .agreeContainer {
    color: #999;
    text-align: left;
    font-size: 0.8em;

    .el-checkbox {
      margin: 0px;
    }
  }

  .el-link.el-link--primary {
    color: #66b1ff;
  }

  .el-link.el-link--primary:hover {
    color: #66b1ff;
  }

  .el-input__inner {
    border-radius: 0px;
    border: 0px;
    border-bottom: 1px solid #dcdfe6;
    background-color: rgba(0, 0, 0, 0);
  }

  .el-form-item__content {
    margin-left: 0px !important;
  }

  .el-input-group__append {
    border-radius: 0px;
    border: 0px;
    background-color: rgba(0, 0, 0, 0);
    padding: 0px;
    border-bottom: 1px solid #dcdfe6;
  }

  .imgCaptcha {
    width: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue